import type { FeatureData } from "./models";

export function renderTechValue(value: string, isInch: boolean, isConverted = false): JSX.Element {
  return <span dangerouslySetInnerHTML={{ __html: value }} />;
}

export function renderTechValueSrpTable(feature: FeatureData, value: string): JSX.Element {
  return <span dangerouslySetInnerHTML={{ __html: value }} />;
}
